// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__1pr9K","Label":"BuildControl_Label__1XW5q","Less":"BuildControl_Less__12Khw","More":"BuildControl_More__2eCie"};